module.exports = __webpack_public_path__ + "static/media/commutativeOr1.ae136b47.JPG";